import React from 'react';
import PropTypes from 'prop-types';
import { Node } from './props';
import isEmpty from 'lodash/isEmpty';
import { css, cx } from 'emotion';
import { Accordion } from '@cimpress/react-components';
import { sky } from '@cimpress/react-components/lib/colors';

const INDENT_AMOUNT_PX = 30;

const getLeafStyle = level =>
  css({
    marginTop: '-1px',
    padding: `16px 16px 16px ${10 + INDENT_AMOUNT_PX * level}px`,
    cursor: 'pointer',
    border: '1px solid #c4cdd6',
    '&:hover': {
      backgroundColor: `${sky.base} !important`
    },
    '&.active': {
      backgroundColor: `${sky.darker} !important`
    }
  });

const accordionTreeStyle = css({
  marginBottom: '0px',
  '& > .accordion-header': {
    border: '1px solid #c4cdd6',
    '&:hover': {
      backgroundColor: `${sky.base} !important`
    },
    '&.active': {
      backgroundColor: `${sky.darker} !important`
    }
  },
  '& .accordion-body': {
    padding: '0px'
  }
});

/**
 * Basic implementation of a tree using Accordion component.
 * Open/closing of non-leaf nodes is controlled by the Accordion.
 */
const TreeNode = ({ node, level, isRoot }) => {
  const isLeaf = isEmpty(node.childrenNodes);

  return isLeaf ? (
    <div className={cx(getLeafStyle(level), node.selected ? 'active' : '')} onClick={node.onClick}>
      {node.content}
    </div>
  ) : isRoot ? (
    node.childrenNodes.map(node => <TreeNode node={node} level={level + 1} key={node.key} />)
  ) : (
    <Accordion
      title={node.content}
      className={accordionTreeStyle}
      headerStyle={{ backgroundColor: 'white', paddingLeft: `${10 + INDENT_AMOUNT_PX * level}px` }}
      style={{ border: 'none', marginTop: '-1px', marginBottom: '0', ...node.style }}
      bodyStyle={{ padding: 0 }}
      defaultOpen={node.defaultOpen}>
      {node.childrenNodes.map(node => <TreeNode node={node} level={level + 1} key={node.key} />)}
    </Accordion>
  );
};

TreeNode.propTypes = {
  node: Node,
  level: PropTypes.number,
  isRoot: PropTypes.bool
};

TreeNode.defaultProps = {
  level: -1,
  isRoot: false
};

const Tree = ({ nodes }) => <TreeNode node={{ childrenNodes: nodes, key: 'root' }} isRoot />;

Tree.propTypes = {
  nodes: PropTypes.arrayOf(Node)
};

Tree.defaultProps = {
  level: -1,
  isRoot: false
};

export default Tree;
